let store = null;

export default function $store(_store) {
  if (!store && _store) {
    store = _store;
  }

  return store;
}

export function resetStore() {
  store = null;
}
